import { useEffect, useRef } from 'react'

export const useOutsideClick = (callback: () => void, className?: string) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Node

      // If className is provided, check if click is inside any element with that class
      if (className) {
        const elements = document.getElementsByClassName(className)
        for (let i = 0; i < elements.length; i++) {
          if (elements[i].contains(target)) {
            return // Click is inside one of the elements, don't trigger callback
          }
        }
        callback()
        return
      }

      // Original behavior: check against single ref
      if (ref.current && !ref.current.contains(target)) {
        callback()
      }
    }

    document.addEventListener('mouseup', handleClickOutside)
    document.addEventListener('touchend', handleClickOutside)

    return () => {
      document.removeEventListener('mouseup', handleClickOutside)
      document.removeEventListener('touchend', handleClickOutside)
    }
  }, [callback, className])

  return ref
}
